"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivacyPolicyPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_markdown_1 = __importDefault(require("react-markdown"));
var policy_1 = require("../../api/calls/client/policy");
var main_1 = require("../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var PrivacyPolicyPage = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)(""), privacyData = _a[0], setPrivacyData = _a[1];
    (0, react_1.useEffect)(function () {
        (0, policy_1.client_policy)().then(function (response) {
            if (response.success) {
                setPrivacyData(response.content.policy);
            }
            else {
                dispatch((0, main_1.setMainModal)({ title: "Something went wrong!", messages: [response.message] }));
            }
        });
    }, []);
    return (react_1.default.createElement("div", { className: "pt-4" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
            react_1.default.createElement(react_markdown_1.default, { className: "flex flex-col gap-4" }, privacyData))));
};
exports.PrivacyPolicyPage = PrivacyPolicyPage;
